import BlogPostAPI from "@api/BlogPost.api";
import type IBlogPost from "@api/models/IBlog";
import type IPagination from "@fetcher/models/IPagination";

import { create } from "zustand";
import { persist } from "zustand/middleware";

const ITEMS_PER_PAGE = 10;

interface BlogState {
  blogs: IBlogPost[];
  pageCount: number;
  currentPage: number;
  totalBlogs: number;
  itemsPerPage: number;

  setBlogs: (blogs: IBlogPost[]) => void;
  setPaginatedBlogs: (pagination: IPagination<IBlogPost>) => void;
  setCurrentPage: (currentPage: number) => void;
}

const useBlogStore = create<BlogState>()(
  persist(
    (set) => ({
      blogs: [],
      pageCount: 1,
      currentPage: 1,
      totalBlogs: 0,
      itemsPerPage: ITEMS_PER_PAGE,

      setPaginatedBlogs: (pagination) => {
        set({
          blogs: pagination.data,
          pageCount: pagination.meta.lastPage,
          totalBlogs: pagination.meta.total,
        });
      },
      setBlogs: (blogs) => {
        set({
          blogs: blogs,
        });
      },
      setCurrentPage: (currentPage) => {
        set({
          currentPage: Math.max(0, currentPage),
        });
        handlePagination();
      },
    }),
    { name: "SecretSmurfsStore-blog" },
  ),
);

export default useBlogStore;

const handlePagination = () => {
  const store = useBlogStore.getState();

  BlogPostAPI.getBlogPosts(store.currentPage, 10).then((response) => {
    store.setPaginatedBlogs(response.data);
  });
};

export const useBlog = (slug?: string) => {
  if (!slug) {
    return;
  }

  const store = useBlogStore((state) => state);
  return store.blogs.find((blog) => blog.slug === slug);
};
